import React from "react"
import { MessageBubble } from "../util"
import _ from "lodash"

const Payload = ({ data, color, isUser }) => {
  let text
  if (data.title) {
    text = data.title
  } else if (data.text) {
    text = data.text
  } else if (data.payload) {
    if (_.isString(data.payload)) {
      text = data.payload
    } else {
      text = JSON.stringify(data.payload, null, 2)
    }
  }
  return (
    <MessageBubble isUser={isUser} color={color} className="text">{text}</MessageBubble>
  )
}

export default Payload
